export default function ScrollTeaser() {

  var scrollTrigger = document.querySelector('.js-scroll-teaser__trigger');

  if (scrollTrigger !== null) {

    var scrollToElement = scrollTrigger.parentNode.parentNode.nextElementSibling;

    scrollTrigger.addEventListener('click', function(e) {

      e.stopPropagation();

      var headerHeight = document.querySelector('.js-header').offsetHeight;

      $('html, body').animate({
          scrollTop: $(scrollToElement).offset().top - headerHeight
      }, 1000);

    });

  }

};
